import useMobileApp from '../mobile-app/useMobileApp';
import useNavigate, { CustomNavigateOptions, UseNavigateInterface } from './useNavigate';
import { To } from '@remix-run/router';
import { Routes } from '../../modules/mobile/exports/Enums';
import { IRouterContext } from '../../modules/mobile/router/Router';
import useMobileRouter from '../../modules/mobile/common/hooks/useMobileRouter';

type RouterType = 'web' | 'mobile';

interface IWebNavigateParams {
  to: To | number;
  options?: CustomNavigateOptions;
}

interface IMobileNavigateParams {
  path: Routes;
  payload?: any;
}

interface INavigateArgs {
  web?: IWebNavigateParams;
  mobile?: IMobileNavigateParams;
}

type BaseRouter = { navigate: (args: INavigateArgs) => void };

type WedRouter = BaseRouter & UseNavigateInterface;
type MobileRouter = BaseRouter & IRouterContext;

type IUseRouter = WedRouter & MobileRouter;

const useRouter = (): IUseRouter => {
  const { isMobileApp } = useMobileApp();
  const mobileRouter = useMobileRouter();
  const webRouter = useNavigate();
  const type = isMobileApp ? 'mobile' : 'web';

  const routers = {
    web: webRouter,
    mobile: mobileRouter,
  };

  const navigate = ({ web, mobile }: INavigateArgs) => {
    const handler = (type: RouterType) =>
      ({
        web: () => web && webRouter.navigate(web.to, web?.options),
        mobile: () => mobile && mobileRouter.navigate(mobile.path, mobile?.payload),
      })[type]();

    isMobileApp ? handler('mobile') : handler('web');
  };

  return {
    ...routers.web,
    ...routers[type],
    navigate,
  } as IUseRouter;
};

export default useRouter;
